/**
 * use-plan.tsx — read the current workspace's plan gates off /api/editor/me.
 *
 * `me.limits` carries the whole tier object (features + shareLinkMaxDays). While
 * `me` is still loading we treat everything as UNLOCKED so paid users never see
 * a lock flash; the server still enforces, so an over-optimistic UI is safe.
 */
import { useMe } from "@/hooks/use-auth";
import type { FeatureKey } from "@/lib/plan-features";

export function usePlan() {
  const { data: me, isLoading } = useMe();
  const limits = me?.limits ?? null;
  return {
    plan: me?.plan ?? null,
    features: limits?.features ?? null,
    shareLinkMaxDays: limits?.shareLinkMaxDays ?? null,
    isLoading,
  };
}

/** True if the current plan grants `key`. Defaults to true until `me` loads. */
export function useHasFeature(key: FeatureKey): boolean {
  const { features } = usePlan();
  if (!features) return true; // loading or no workspace — let the server gate
  return !!features[key];
}
